import component from "./component"
import TC from "../termsAndConditionsState"
import connector from "../../../utils/reduxRouter/connector"

const mapState = (state: { sessionReducer: { tcManager: TC } }) => ({
  tcManager: state.sessionReducer.tcManager,
})

const mapDispatch = () => ({})

export default connector({
  mapState,
  mapDispatch,
  component,
})
